/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const CATALOG_ID_B2B_SC_PUBLIC = '11101';
export const CATALOG_ID_B2B_SC = '11601';
